// import {
//   Flex,
//   Box,
//   FormControl,
//   FormLabel,
//   Input,
//   Checkbox,
//   Stack,
//   Link,
//   Button,
//   Heading,
//   useColorModeValue,
// } from "@chakra-ui/react";
// import axios from "axios";
// import { useState } from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import swal from "sweetalert";
// // login check
// import { useAuth } from "../Context/Auth";
// export const Login = () => {
//   const [user, setUser] = useState("");
//   const auth = useAuth();
//   const navigate = useNavigate();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const handleLogin = (email, password) => {
//     auth.login(!user); /* auth */
//     axios
//       .post("https://shy-rose-trout-sock.cyclic.app/login", {
//         email: email,
//         password: password,
//       })
//       .then((res) => {
//         swal("Access Allowed!", "", "success");
//         navigate("/");
//         console.log(res.data);
//       })
//       .catch((e) => {
//         console.log(e.message);
//         // alert("Password is Wrong");
//         swal("Password is Wrong!", "", "error");
//         navigate("/signup");
//       });
//   };

//   const handleEmail = (e) => {
//     setEmail(e.target.value);
//   };
//   const handlePassword = (e) => {
//     setPassword(e.target.value);
//   };

//   return (
//     <Flex
//       minH={"100vh"}
//       align={"center"}
//       justify={"center"}
//       bg={useColorModeValue("gray.50", "gray.800")}
//     >
//       <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6}>
//         <Stack align={"center"}>
//           <Heading fontSize={"4xl"}>Log In </Heading>
//         </Stack>
//         <Box
//           rounded={"lg"}
//           bg={useColorModeValue("white", "gray.700")}
//           w="350px"
//           boxShadow={"lg"}
//           p={8}
//         >
//           <Stack spacing={4}>
//             <FormControl id="email">
//               <FormLabel>Email address</FormLabel>
//               <Input type="email" onChange={handleEmail} />
//             </FormControl>
//             <FormControl id="password">
//               <FormLabel>Password</FormLabel>
//               <Input type="password" onChange={handlePassword} />
//             </FormControl>
//             <Stack spacing={10}>
//               <Stack
//                 direction={{ base: "column", sm: "row" }}
//                 align={"start"}
//                 justify={"space-between"}
//               >
//                 <Checkbox>Remember me</Checkbox>
//                 <Link color={"blue.400"}>Forgot password?</Link>
//               </Stack>
//               <Button
//                 onClick={() => {
//                   handleLogin(email, password);
//                 }}
//                 bg={"blue.400"}
//                 color={"white"}
//                 _hover={{
//                   bg: "blue.500",
//                 }}
//               >
//                 Login in
//               </Button>
//             </Stack>
//             <Stack pt={6}>
//               <NavLink color={"blue.400"} to="/signup">
//                 Cretae Account
//               </NavLink>
//             </Stack>
//           </Stack>
//         </Box>
//       </Stack>
//     </Flex>
//   );
// };

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  Link,
  Button,
  Heading,
  useColorModeValue,
} from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

// login check
import { useAuth } from "../Context/Auth";
import swal from "sweetalert";
export const Login = () => {
  const [user, setUser] = useState("");
  const auth = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (email, password) => {
    auth.login(!user); /* auth */
    axios
      .post("https://shy-rose-trout-sock.cyclic.app/login", {
        email: email,
        password: password,
      })
      .then((res) => {
        swal("Login Successfully!", "", "success");
        navigate("/flatform");
        console.log(res.data);
      })
      .catch((e) => {
        console.log(e.message);
        // alert("Password is Wrong");
        swal("Password is Wrong!", "", "warning");

        navigate("/signup");
      });
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
      bg="rgb(15,6,23)"
    >
      <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6}>
        <Stack align={"center"}>
          <Heading fontSize={"4xl"} color="white">
            Log In
          </Heading>
        </Stack>
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          w="350px"
          boxShadow={"lg"}
          p={8}
        >
          <Stack spacing={4}>
            <FormControl id="email">
              <FormLabel>Email address</FormLabel>
              <Input type="email" onChange={handleEmail} />
            </FormControl>
            <FormControl id="password">
              <FormLabel>Password</FormLabel>
              <Input type="password" onChange={handlePassword} />
            </FormControl>
            <Stack spacing={10}>
              <Stack
                direction={{ base: "column", sm: "row" }}
                align={"start"}
                justify={"space-between"}
              >
                <Checkbox>Remember me</Checkbox>
                <Link color={"blue.400"}>Forgot password?</Link>
              </Stack>
              <Button
                onClick={() => {
                  handleLogin(email, password);
                }}
                bg={"blue.400"}
                color={"white"}
                _hover={{
                  bg: "blue.500",
                }}
              >
                Login
              </Button>
            </Stack>
            <Stack pt={6}>
              <NavLink color={"blue.400"} to="/signup">
                Cretae Account
              </NavLink>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Flex>
  );
};
